import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {useCompanyInviteRoleUserPopupStore} from './company-invite-role-user-store'
import {ProjectListItem} from './project-list-item'

const TwEmpty = tw.div`
  text-secondary
  text-xs-regular
  cursor-default
`

export const ProjectList = observer(() => {
  const [, store] = useCompanyInviteRoleUserPopupStore()
  if (!store.projects.length) {
    return <TwEmpty>{Lang.msg.invitePopup.noProjects}</TwEmpty>
  }

  return (
    <WithPerfectScrollbar className="min-h-100 max-h-200">
      {store.projects.map(p => (
        <ProjectListItem key={p.id} project={p} />
      ))}
    </WithPerfectScrollbar>
  )
})
